import ScrollFunc from './scrollfunc.es6';

export default class Main {
    constructor() {
        window.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {
        this.scrollfunc = new ScrollFunc();
    }
}
